import api from '../../../api';
import * as deleteMessage from '../../../modules/trader-chat/actions/delete-message';

export function request(dispatch, { chatId, messageId }) {
    api.del('/chats/' + chatId + '/messages/' + messageId)
        .then(() => {
            dispatch(deleteMessage.finish(chatId, messageId));
        },
        (data) => dispatch(deleteMessage.error(chatId, data.errors))
    );
}
